import { render, staticRenderFns } from "./MaterialsOrderGroup.vue?vue&type=template&id=3682b4db&scoped=true"
import script from "./MaterialsOrderGroup.vue?vue&type=script&lang=js"
export * from "./MaterialsOrderGroup.vue?vue&type=script&lang=js"
import style0 from "./MaterialsOrderGroup.vue?vue&type=style&index=0&id=3682b4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3682b4db",
  null
  
)

export default component.exports